module.exports = __webpack_public_path__ + "static/media/qa.4f997308.svg";